import { FC } from 'react';

import { CancelButton, RequestButton } from './buttons';
import { Spacer } from './spacer';

export const CreatingActions: FC = () => (
  <>
    <CancelButton className="flex-grow-1" />
    <Spacer />
    <RequestButton className="flex-grow-1" />
  </>
);
